<man-user-form
  *ngIf="user$ | async as user"
  [loading]="loading$ | asyncNotNull"
  [saving]="saving$ | asyncNotNull"
  [disabled]="disabled$ | asyncNotNull"
  [user]="user"
  (save)="onSave($event)"
  (stateChange)="onStateChange($event)"
></man-user-form>
